// theme.js
export const theme = {
    colors: {
        primary: '#333',       // אפור
        accent: '#f9b5d0',        // ורוד בהיר להיילייטים
        secondary: '#e75fa5;',     // סגול בהיר כגוון משלים
        background: '#fffafc',    // רקע רך ונעים
        text: '#333',             // אפור
        
    },
    backgroundColors: {
        primary: '#fffafc',       // רקע לבן רך ונעים
        primaryTransparent: '#fefafa',
    },
    breakpoints: {
        mobile: '480px',
        tablet: '768px',
        laptop: '1024px',
    },
};
